<div class="footer-bg-img">
    <div class="footer-container" *ngIf="globalService?.showTeamLogos">
        <div class="footer-text"> &copy; 2025 Ernst & Young LLP. All rights reserved.</div>
    </div>
</div>